<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">
        <div class="columns">
            <div class="column is-3"><button class="button is-medium is-fullwidth is-primary" v-on:click="goManageClasses()">Classes &amp; Students</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageTeachers()">Teachers</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBehaviors()">Behaviors</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageNotifications()">Notifications</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageGroups()">Groups</button></div>
            <!-- <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBadges()">Badges</button></div> -->
        </div>
        
        <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li>
                    <a v-on:click="goManageClasses()">Classes</a>
                </li>
                <li>
                    <a href="#">{{ className }}</a>
                </li>
                <li class="is-active">
                    <a href="#" aria-current="page">Import Duplicate Students</a>
                </li>
            </ul>
        </nav>

        <div class="columns">
            <div class="column is-12">
                <div class="card">
                    <loading :active.sync="isLoading1" 
                        :can-cancel="false" 
                        :is-full-page="false">
                    </loading>
                    <div class="card-header">
                        <p class="card-header-title">Duplicated Students</p>
                    </div>
                    <div class="card-content">
                        
                        
                        <div class="content">
                                    <h3>Below are the list of students who're already in this school. Please select the students who you want to import from the data inside the excel. Take note that this will REMOVE ALL the overwritten student's data and QR tags.</h3>
                                    <br/>
                                    <div class="columns bottom-border">
                                        <div class="column">Name</div>
                                        <div class="column">Father's Name</div>
                                        <div class="column">Father's ID</div>
                                        <div class="column">Mother's ID</div>
                                        <div class="column" style="text-align:right;"><center>
                                            <a class="button is-warning is-small" v-on:click="importSelectedStudents()">Import Selected</a>
                                            <a class="button is-primary is-small" v-on:click="goManageClasses()">Skip</a>
                                            </center>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column">&nbsp;</div>
                                        <div class="column">&nbsp;</div>
                                        <div class="column">&nbsp;</div>
                                        <div class="column">&nbsp;</div>
                                        <div class="column" style="text-align:right;"><center>
                                            <a class="button is-small is-outlined" v-on:click="checkAll">Check all</a>
                                            </center>
                                        </div>
                                    </div>

                                    <div class="columns" v-for="(student) in sortData(duplicatedStudentList)" :key="student.duplicatedStudentID">
                                        <div class="column">{{ student.firstName }} </div>
                                        <div class="column">{{ student.father }}</div>
                                        <div class="column">{{ student.fatherID }}</div>
                                        <div class="column">{{ student.motherID }}</div>
                                        <div class="column" style="text-align:right;"><center><input type="checkbox"  :value="student.duplicatedStudentID" :id="student.duplicatedStudentID" v-model="student.checked"></center></div>
                                    </div>
                                </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./../../NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import ImportStudents from './ImportStudents';
import AddStudents from './AddStudents';
import StudentList from './StudentList';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "../../public/style.scss";

export default {
    name: "ManageStudentsImportDuplicate",
    components: {
        NewTopMenu,
        Loading,
        ImportStudents,
        AddStudents,
        StudentList
    },
    data() {
        return {
            kelasID: "",
            className: "",
            duplicatedStudentList: [],
            isLoading1: false,
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    methods: {
        importSelectedStudents(data){

            let self = this;
            var studentsToImport = [];

            this.duplicatedStudentList.forEach(function(element) {
                if (element.checked){
                    studentsToImport.push(element)
                }else{
                    element.checked = false
                }
            });
            
            console.log("studentsToImport.length: " + studentsToImport.length)
            console.log("element checked ")
            
            console.log("180 duplicatedStudentList")
            console.log(this.duplicatedStudentList)
            console.log("182 studentsToImport")
            console.log(studentsToImport)
            
            if (studentsToImport.length > 0){                
            
                this.$swal({
                    title: "Are you sure?",
                    text: "Selected students' inside the database will be REMOVED and REPLACED with the data from excel. All selected students' data including behavior points WILL BE PERMANENTLY REMOVED. You will also have to PRINT NEW QR for the imported students, as the old QR tags for these students will not be usable anymore. Are you really sure you want to do this?",
                    showCancelButton: true,
                    confirmButtonText: 'Yes, proceed',
                    cancelButtonText: 'No, cancel',
                    showCloseButton: true
                }).then((result) => {
                    if (result.value){

                        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                        axios.defaults.responseType = 'json'
                        axios.post(process.env.MY_URL + '/studentsV2/importDuplicate',{
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            kelasID: self.kelasID,
                            duplicatedStudentList: studentsToImport
                        })

                            .then(response => {
                                console.log("182 response.data: ")
                                console.log(response.data)
                                if (response.data.success == false) {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    })
                                    
                                    this.$router.push({
                                    name: 'ManageStudentsHome'
                                })

                            } else {
                                Toast.open({
                                    color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 5000
                                })
                                this.$router.push({
                                    name: "ManageStudentsHome"
                                });
                            }
                        })
                        .catch(e => {
                            console.log("172?")
                            console.log(e)
                            if (e.response.status === 401) {
                                console.log("salah login")
                                this.errors.push("Invalid login")                            
                                alert("Unauthorized access. Please re-login.")
                            } else {
                                this.errors.push(e)
                            }
                        })
                }
            });

            }else{
                alert("Please select the student(s) you want to import first.")
                return false;
            }
            
        },


        checkAll: function() {
            this.duplicatedStudentList = this.duplicatedStudentList.map(student => ({ ...student,
                checked: !this.isAllChecked
            }))
            this.isAllChecked = !this.isAllChecked
        },
        sortData(arrays){
            return _.orderBy(arrays, 'firstName', 'asc');  //we're using the magical lodash function here            
        },
        goManageClasses(){
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageTeachers(){
            this.$router.push({
                name: "ManageTeachersHome"
            });
        },
        goManageBehaviors(){
            this.$router.push({
                name: "ManageBehaviorsHome"
            });
        },
        goManageNotifications(){
            this.$router.push({
                name: "ManageNotificationsHome"
            });
        },
        goManageGroups(){
            this.$router.push({
                name: "ManageGroupsHome"
            });
        },
        goManageBadges(){
            this.$router.push({
                name: "ManageBadgesHome"
            });
        },
    },
    created() {
        // this.kelasID = this.$store.getters.getClassesDashboardSingleID;
        this.kelasID = localStorage.getItem('importToKelasId')

        if (this.kelasID.trim.length < 1){
            this.kelasID = localStorage.getItem('CLASSES_DASHBOARD_SINGLE_ID')
        }

        console.log("this.kelasID: " + this.kelasID)
        this.className = this.$store.getters.getClassesDashboardSingleName;

        if (this.className.trim.length < 1){
            this.className = localStorage.getItem('CLASSES_DASHBOARD_SINGLE_NAME')
        }
        console.log("this.className: " + this.className)

        this.duplicatedStudentList = JSON.parse(localStorage.getItem('duplicatedStudentList'))
        console.log("kelasID: " + this.kelasID)
        console.log(this.kelasID)
        console.log("duplicatedStudentList.length: " + this.duplicatedStudentList.length)
        console.log(this.duplicatedStudentList)
    },
    mounted(){
    },
};
</script>

<style scoped>
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Students/ImportDuplicate.vue